import { render, staticRenderFns } from "./OceanDestination.vue?vue&type=template&id=34ec6143&scoped=true"
import script from "./OceanDestination.vue?vue&type=script&lang=js"
export * from "./OceanDestination.vue?vue&type=script&lang=js"
import style0 from "./OceanDestination.vue?vue&type=style&index=0&id=34ec6143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec6143",
  null
  
)

export default component.exports